import { render, staticRenderFns } from "./kalemgemi.vue?vue&type=template&id=5f5cd71a&"
import script from "./kalemgemi.vue?vue&type=script&lang=js&"
export * from "./kalemgemi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports